<sbnb-signup-wizard-template>
  <ng-container left-side>
    <h1 class="text-2xl md:text-3xl mb-8">Verify your account</h1>
    <p class="mb-6">
      We've sent a one time code to {{ signupUserService.user$.value?.mobile_phone }}. Enter the code we've sent to
      continue. This code is valid for 10 minutes.
    </p>

    <sbnb-otp-input [size]="otpSize" [(ngModel)]="otp"></sbnb-otp-input>

    <sbnb-button
      class="block mt-8"
      [fullWidth]="true"
      [disabled]="otp.length !== otpSize"
      [loading]="isValidating"
      (clicked)="onContinue()">
      Continue
    </sbnb-button>

    <ng-container *ngIf="(codeRecentlyRequested$ | async) === false; else codeRecentlyRequestedTemplate">
      <p *ngIf="cooldownActive" class="mt-8 text-sm">
        Didn't receive the code? You can request another in {{ cooldownTimeSeconds }} seconds.
      </p>
      <p *ngIf="!cooldownActive" class="mt-8 text-sm">
        Didn't receive the code?
        <a class="inline-block ml-1 grass-darker cursor-pointer font-extrabold not-italic" (click)="requestNewCode()">
          Resend
        </a>
      </p>
    </ng-container>

    <ng-template #codeRecentlyRequestedTemplate>
      <p class="mt-8 text-sm grass-darker font-extrabold">A new code has been sent to your phone.</p>
    </ng-template>
  </ng-container>

  <img right-side src="/assets/images/signup/password.svg" />
</sbnb-signup-wizard-template>
